import { Component, OnInit, OnDestroy } from '@angular/core';
import { showOpacityAnimation } from '../../../animations/show-left-right.animation';
import { PatientService } from 'src/app/services/patient.service';
import { IDogList, IPatient } from 'src/app/interfaces/patient.interfaces';
import { lastValueFrom, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { LoadService } from 'src/app/services/application/load.service';
import { ContractService } from 'src/app/services/contract.service';
import { AlertService } from 'src/lib/ariadna/alert';
import { AuthService } from 'src/app/services/auth.service';
import { Utils } from 'src/app/services/utils';
import { CookieConsentService } from 'src/app/services/cookie-consent/cookie-consent-service';
@Component({
    selector: 'app-auth-sign-documents',
    templateUrl: './sign-documents.component.html',
    styleUrls: ['../_auth-shared-styles.scss'],
    animations: [showOpacityAnimation],
    standalone: false,
})
export class SignDocumentsComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    public isLoading = false;
    public patient: IPatient | null = null;
    public contractList: IDogList[] = [];
    public contractPreviewRequired: boolean;
    public showBackArrow: boolean = true;
    public errorMessage: string = '';
    public constructor(
        private ps: PatientService,
        private contractService: ContractService,
        private auth: AuthService,
        private load: LoadService,
        private alertService: AlertService,
        private cookieService: CookieConsentService,
        private router: Router,
    ) {
        this.contractPreviewRequired =
            !!this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .IS_REQUIRED_CONTRACT_PREVIEW;
    }

    public ngOnInit(): void {
        this.patient = this.ps.currentPatient;
        this.getContractsToSigh();
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
    // Получить список документов
    private getContractsToSigh(): void {
        this.isLoading = true;
        const docs = this.contractService.getDocuments();
        if (!docs || docs.length === 0) {
            this.router.navigate(['/home']);
            return;
        }
        this.contractList = docs;
        this.isLoading = false;
    }
    // просмотр документа по клику
    public async clickContract(contractId: number) {
        const currentContract = this.contractList.find(
            (contract) => contract.id === contractId,
        );
        if (currentContract) currentContract.mark = false;
        this.isLoading = true;
        try {
            const contract = await lastValueFrom(
                this.contractService.getContractPdf(
                    contractId.toString(),
                    this.cookieService.getParentCookieData(),
                ),
            );
            if (!contract) {
                this.alertService.warn(
                    'Документ поврежден! Обратитесь в медицинскую организацию',
                );
                return;
            }
            const file = new File(
                [new Uint8Array(contract.data)],
                `contract_${contractId}.pdf`,
                {
                    type: 'application/pdf',
                },
            );

            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;

            link.rel = 'noopener noreferrer';
            link.download = `contract_${contractId}.pdf`;

            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
                document.body.removeChild(link);
                URL.revokeObjectURL(fileURL);
            }, 60_000);
        } catch (err: any) {
            this.errorMessage = Utils.getErrorMessage(
                err,
                'Ошибка при загрузке PDF',
            );
            console.error('Ошибка при загрузке PDF', this.errorMessage);
        } finally {
            this.isLoading = false;
        }
    }
    // Подписать документ
    public goSignature(docId: number) {
        this.isLoading = true;
        this.contractService
            .signContract(docId, this.cookieService.getParentCookieData())
            .subscribe({
                next: (result) => {
                    const resData = Array.isArray(result) ? result[0] : result;
                    if (resData?.id) {
                        this.alertService.success(
                            'Документ успешно подписан',
                            5000,
                        );
                        this.contractList = this.contractList.filter(
                            (contr) => String(contr.id) !== String(docId),
                        );

                        if (this.contractList.length === 0) {
                            this.cookieService.setCookie(
                                'pa-web_Patient_Local',
                                this.contractService.getToken() || '',
                            );
                            this.router.navigate(['/home']);
                        }
                    } else {
                        this.alertService.error(
                            'Сервер не вернул идентификатор подписанного документа',
                            5000,
                        );
                    }

                    this.isLoading = false;
                },
                error: (err: any) => {
                    this.errorMessage = Utils.getErrorMessage(
                        err,
                        'Ошибка при подписании',
                    );
                    console.error('SIG ERR=', this.errorMessage);
                    this.isLoading = false;
                },
            });
    }
    public backToLogin() {
        this.auth.logout();
        this.router.navigate(['/auth/login']);
    }
}
// import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import {
//     IContractSigningResponse,
//     IDogList,
//     IPatient,
//     ITokenAndPatientId,
// } from '../../../interfaces/patient';
// import { AuthService } from '../../../services/auth.service';
// import { ConfigService } from '../../../services/application/config.service.';
// import { PatientService } from '../../../services/patient.service';
// import { Router } from '@angular/router';
// import { CookieConsentService } from 'src/app/services/cookie-consent-service';

// @Component({
//     selector: 'app-dog-list',
//     templateUrl: './dog-list.component.html',
//     styleUrls: ['./dog-list.component.scss'],
// })
// export class DogListComponent implements OnInit {

//     /*
//         @Input() patient: IPatient | null = null; //Текущий пациент
//     */
//     @Input() tmpToken: ITokenAndPatientId | null = null; //токен
//     @Input() tokens: string | null = null;
//     @Output() onError = new EventEmitter<string>(); // Ошибка
//     @Output() onEvent = new EventEmitter<string>(); // Ошибка
//     @Input() dogPREVIEW_REQUIRED: boolean = false; // Обязательность предпросмотра

//     public patient: IPatient | null = null; //Текущий пациент
//     public error = '';

//     public dogList!: IDogList[]; // Список договоров
//     //    private dogPREVIEW_REQUIRED: boolean = false; // Обязательность предпросмотра
//     //    public showDoglist = false;
//     public dogHoverId: number = 0; // Наведенный договор, если нет то = 0
//     loading = false; // Загрузка

//     constructor(
//         private auth: AuthService,
//         private configS: ConfigService,
//         private ps: PatientService,
//         private router: Router,
//         private cookieService: CookieConsentService
//     ) {}

//     ngOnInit(): void {
//         this.dogHoverId = 0;
//         if (this.tmpToken) {
//             this.loginDoc();
//         }
//     }

//     /* Получение списка договоров */
//     private loginDoc(): void {

//         this.loading = true;
//         this.dogList = [];
//         this.auth.getContractList(this.tmpToken!).subscribe(
//             (response) => {
//                 if (response && response.length > 0) {
//                     response.forEach((item) => {
//                         // Получаем информацию о пациенте
//                         this.ps.getServerPatientInfo$().subscribe(
//                             (info) => {
//                                 this.patient = info;
//                                 this.patient.birthDate = null;
//                             },
//                             (err) => {
//                                 this.patient = null;
//                             }
//                         );

//                         this.dogList.push({
//                             id: item.templateId,
//                             text: item.templateName,
//                             Сh: false,
//                             Url: `/contract/preview?contractId=${item.templateId}`,
//                         });
//                     });
//                     this.error = '';
//                 } else {
//                     // Если нет договоров то продолжаем
//                     this.loginOK();
//                 }
//                 this.loading = false;
//             },
//             (error) => {
//                 this.loading = false;
//                 console.error('error=', error);
//             }
//         );
//     }

//     /* Назад */
//     logout(): void {
//         this.onEvent.emit('LOGOUT');
//     }

//     public disableDog(id: number): boolean {
//         let f = false;
//         if (this.dogPREVIEW_REQUIRED) {
//             this.dogList.forEach((item) => {
//                 if (item.id === id) {
//                     // @ts-ignore
//                     f = item.Сh;
//                 }
//             });
//         } else {
//             f = true;
//         }
//         return f;
//     }

//     /* Подписание договора */
//     public goSignature(templateId: number): void {
//         //
//         this.loading = true;
//         this.auth.postContract(this.tmpToken!, templateId).subscribe(
//             (result: IContractSigningResponse[]) => {
//                 this.loading = false;
//                 if (result[0] && result[0].id) {
//                     this.dogList.forEach((item, i) => {
//                         item.id === templateId && this.dogList.splice(i, 1);
//                     });
//                 } else {
//                     this.error = 'Что-то пошло не так';
//                     this.onError.emit(this.error);
//                 }
//                 if (
//                     !this.dogList ||
//                     (this.dogList && this.dogList.length === 0)
//                 ) {
//                     this.loginOK();
//                 }
//             },
//             (error) => {
//                 console.error('SIG ERR=', error);
//                 if (error) {
//                     this.error = error;
//                 } else {
//                     this.error = 'Что то пошло не так при подписании!';
//                 }

//                 this.onError.emit(this.error);

//                 this.loading = false;
//             }
//         );
//     }

//     public onHoverDog(id: number) {
//         // on-mouseover
//         //
//         this.dogHoverId = id;
//     }

//     public onMouseout(id: number) {
//         // on-mouseleave on-mouseout (одинаково работают)
//         //
//         this.dogHoverId = 0;
//     }

//     /* просмотр договора */
//     public clickDog(id: number): void {
//         let url = '';
//         this.dogList.forEach((item) => {
//             if (item.id === id) {
//                 item.Сh = true;
//                 url = item.Url!;
//             }
//         });
//         window.open(`${this.configS.getValue('hostBackend')}${url}`, '_blank');
//     }

//     public loginOK(): void {
//         this.setCookies(this.tokens!);
//         this.onEvent.emit('LOGINOK');
//     }

//     private setCookies(token: string): void {
//         if (!document.cookie.includes('cookieconsent_status')) {
//             this.cookieService.setCookie('cookieconsent_status', 'true');
//         }
//         this.cookieService.setCookie('pa-web_Patient_Local', token);
//     }
// }
